import React from 'react';
import PropTypes from 'prop-types';

interface ICalendarProps {
  title?: string;
  dateLine1?: string;
  dateLine2?: string;
}

class Calendar extends React.Component<ICalendarProps> {
  static propTypes = {
    title: PropTypes.string,
    dateLine1: PropTypes.string,
    dateLine2: PropTypes.string,
  };

  static defaultProps = {
    title: '',
    dateLine1: '',
    dateLine2: '',
  };
  render() {
    const { title, dateLine1, dateLine2 } = this.props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="146" height="142" viewBox="0 0 146 142">
        <g fill="none" fillRule="nonzero">
          <g>
            <rect fill="#DC0023" x="0" y="10" width="146" height="41" />
            <text
              className="title"
              fill="#ffffff"
              x="50%"
              y="33"
              dominantBaseline="middle"
              textAnchor="middle"
              fontSize="12px"
            >
              {title}
            </text>
          </g>

          <g>
            <rect fill="#F5F6F7" x="0" y="51" width="146" height="90" />
            <text
              className="dateLine1"
              fill="#474e52"
              x="50%"
              y="90"
              dominantBaseline="middle"
              textAnchor="middle"
              fontSize="22px"
              fontWeight="bold"
            >
              {dateLine1}
            </text>
            <text
              className="dateLine2"
              fill="#474e52"
              x="50%"
              y="115"
              dominantBaseline="middle"
              textAnchor="middle"
              fontSize="15px"
            >
              {dateLine2}
            </text>
          </g>

          <path fill="#E8E9EA" d="M0 141h146v1H0z" />
          <g fill="#3B4144" transform="translate(35)">
            <rect width="10" height="20" rx="5" />
            <rect width="9" height="20" x="67" rx="4.5" />
          </g>
        </g>
      </svg>
    );
  }
}
export default Calendar;
